import moment from 'moment';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';

import config from '../constants/config';
import { ONE_WAY } from '../constants/generic';
import { getAWayFromContract } from '.';

export const validateSearch = (values = {}, ctx = {}) => {
  const errors = {};
  const { messages = {} } = ctx.i18n || {};
  const { contract } = ctx || {};

  const tripType = _isEmpty(ctx.bookingTypeValues)
    ? getAWayFromContract(ctx.contract)
    : ctx.bookingTypeValues.tripType;

  if (
    contract &&
    contract.businessCarSharing &&
    contract.privateCarSharing &&
    !_isEmpty(ctx.user)
  ) {
    if (!values.usageTypes) {
      errors.usageTypes = messages['error.form.required'];
    }
  }

  if (!values.startDate) {
    errors.startDate = messages['error.form.required'];
  }

  if (!values.startTime) {
    errors.startTime = messages['error.form.required'];
  }

  if (tripType !== ONE_WAY) {
    if (!values.endDate) {
      errors.endDate = messages['error.form.required'];
    }

    if (!values.endTime) {
      errors.endTime = messages['error.form.required'];
    }
  }

  if (tripType !== ONE_WAY) {
    if (values.startDate && values.endDate) {
      if (moment(values.endDate).diff(values.startDate, 'days') < 0) {
        errors.startDate = messages['error.form.required'];
        errors.endDate = messages['error.form.required'];
      }
    }

    if (values.startDate && values.startTime && values.endDate && values.endTime) {
      if (
        moment(values.endDate + 'T' + values.endTime).diff(
          values.startDate + 'T' + values.startTime,
          'minutes'
        ) < config.minimumBookingDurationMinutes
      ) {
        errors.endTime = messages['error.form.required'];
      }
    }

    if (values.startDate && values.startTime) {
      if (moment().diff(values.startDate + 'T' + values.startTime, 'minutes') > 0) {
        errors.startTime = messages['error.form.required'];
      }
    }
  }

  if (
    !values.location ||
    (typeof values.location === 'object' && _isEmpty(values.location))
  ) {
    errors.location = messages['error.form.required'];
  }

  if (values.location) {
    if (_isString(values.location.value)) {
      errors.location = messages['error.form.suggestion.address.required'];
    }
  }

  return errors;
};
